<template>
<div>
    <SearchBox ref="SearchBox">
        <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="100px"
                 class="unitWidth" size="small">
            <el-form-item label="所属工厂">
                <el-select v-model="fcIdSelected" placeholder="请选择工厂" :clearable="isclear" filterable
                           :disabled="ischeck" @change="fcChange">
                    <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label"
                               :value="factory.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属车间">
                <el-select v-model="shopSelected" placeholder="请选择车间" clearable filterable @change="shopChange"
                           :disabled="scopeSelected == 'factory' || scopeSelected == 'company'">
                    <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label"
                               :value="shop.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属工段">
                <el-select
                    v-model="sectionSelected"
                    placeholder="请选择工段"
                    clearable
                    filterable
                    @change="sectionChange"
                    :disabled="scopeSelected == 'shop' || scopeSelected == 'factory' || scopeSelected == 'company'"
                >
                    <el-option v-for="section in sectionList" :key="section.value" :label="section.label"
                               :value="section.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属产线">
                <el-select
                    v-model="lineSelected"
                    placeholder="请选择产线"
                    clearable
                    filterable
                    @change="lineChange"
                    :disabled="scopeSelected == 'shop' || scopeSelected == 'factory' || scopeSelected == 'company' || scopeSelected == 'vsm'"
                >
                    <el-option v-for="line in lineList" :key="line.value" :label="line.label"
                               :value="line.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设备编号">
                <el-input v-model.trim="devCode" placeholder="请输入设备编号"></el-input>
            </el-form-item>
            <el-form-item label="设备名称">
                <el-input v-model.trim="devName" placeholder="请输入设备名称"></el-input>
            </el-form-item>
			<el-form-item label="运行状态">
			    <el-select v-model="devRunStatus" placeholder="请选择" clearable @change="searchTable">
			        <el-option label="计划停机" value="in_halt"></el-option>
			        <el-option label="运行" value="in_run"></el-option>
			        <el-option label="调试" value="in_idle"></el-option>
			        <el-option label="故障" value="in_fault"></el-option>
			    </el-select>
			</el-form-item>
			<el-form-item label="状态">
			    <el-select v-model="devStatus" placeholder="请选择" clearable @change="searchTable">
			        <el-option label="使用中" value="101"></el-option>
			        <el-option label="闲置中" value="102"></el-option>
			        <el-option label="报废中" value="103"></el-option>
			        <el-option label="移管中" value="104"></el-option>
			    </el-select>
			</el-form-item>
            <el-form-item label="固定资产编号">
                <el-input v-model.trim="assetsNo" placeholder="请输入固定资产编号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchTable">查询</el-button>
                <el-button type="primary" @click="addDevice" v-for="acc in access" v-if="acc == 'DE0001'">新增
                </el-button>
                <el-button v-if="isSkip" @click="getFacility">返回</el-button>
            </el-form-item>
        </el-form>
    </SearchBox>
    <LabelContent title="设备列表" ref="LabelContent">
        <div slot="btns">
            <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
            <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
            <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
            <el-button size="small" type="success" @click="exportDevice">设备导出</el-button>
            <el-button size="small" type="success" @click="deviceTemplate" v-for="acc in access"
                       v-if="acc == 'DE0004'">设备模板
            </el-button>
            <el-button size="small" type="success" @click="deviceImport" v-for="acc in access"
                       v-if="acc == 'DE0005'"> 设备导入
            </el-button>
            <el-button size="small" type="success" @click="planMaintainTemplate" v-for="acc in access"
                       v-if="acc == 'DE0006'">计划保养项模板
            </el-button>
            <el-button size="small" type="success" @click="planMaintainImport" v-for="acc in access"
                       v-if="acc == 'DE0007'">计划保养项导入
            </el-button>
            <el-button size="small" type="success" @click="dailyCheckItemTemplate" v-for="acc in access"
                       v-if="acc == 'DE0008'">点检项模板
            </el-button>
            <el-button size="small" type="success" @click="dailyCheckItemImport" v-for="acc in access"
                       v-if="acc == 'DE0009'">点检项导入
            </el-button>
        </div>
    </LabelContent>
    <div class="tableBox">
        <el-table stripe ref="multipleTable" :data="tableData" class="center">
            <!--                <el-table-column type="selection" width="55" />-->
            <el-table-column prop="devCode" label="设备编号"/>
            <el-table-column prop="devName" label="设备名称" width="130"/>
            <el-table-column prop="assetsNo" label="固定资产编号" width="110"/>
            <el-table-column prop="yearOfManu" label="出厂年份" width="100"/>
            <el-table-column prop="dateOfArri" label="进厂日期" :formatter="dateFormat" width="100"/>
            <el-table-column prop="serviceLife" label="使用年限"/>
            <el-table-column prop="fcName" label="所属工厂" width="130"/>
            <el-table-column prop="shopName" label="所属车间"/>
            <el-table-column prop="sectionName" label="所属工段"/>
            <el-table-column prop="lineName" label="所属产线"/>
            <el-table-column prop="mesLineCode" label="SAP所属产线" width="110"/>
            <el-table-column prop="devRunStatus.desc" label="运行状态"/>
            <!--                <el-table-column prop="devsRelative" label="关联设备" show-overflow-tooltip />-->
            <el-table-column prop="devStatus" label="状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.devStatus == '101'">使用中</span>
                    <span v-if="scope.row.devStatus == '102'">闲置中</span>
                    <span v-if="scope.row.devStatus == '103'">报废中</span>
                    <span v-if="scope.row.devStatus == '104'">移管中</span>
                </template>
            </el-table-column>
            <!--                <el-table-column prop="createUser" label="创建用户" width="100"/>-->
            <el-table-column prop="note" label="设备位置"/>
            <el-table-column prop="personNo" label="责任人工号" width="100"/>
            <el-table-column prop="person" label="责任人" show-overflow-tooltip/>
            <el-table-column prop="keyDevices" label="是否关键设备" width="110">
                <template slot-scope="scope">
                    <span>{{ scope.row.keyDevices == true ? '是' : '否' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="devSupplier" label="供应商"/>
            <el-table-column prop="devSupConInf" label="供应商联系方式" width="150"/>
            <el-table-column prop="devSupplierAddress" label="供应商地址" width="110"/>
            <el-table-column label="操作" width="120" fixed="right">
                <template slot-scope="scope">
                    <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                    <!--<i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false),updatehOpen(scope.row)" />
                <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" />-->
                    <!--<i class="document el-icon-circle-plus-outline" @click="getDeviceOpcConfigList(scope.row)"/>-->
                    <i class="editBtn iconfont u-youjianbianji" @click="deviceEditor(scope.row)"
                       v-for="acc in access" v-if="acc == 'DE0002'"/>
                    <i class="delBtn iconfont u-shanchu" @click="deleteDevice(scope.row)" v-for="acc in access"
                       v-if="acc == 'DE0003'"/>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <el-pagination
        @size-change="paginationChange"
        @current-change="paginationCurrentChange"
        :current-page="searchParams.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchParams.pageCount"
    />
    <el-dialog title="设备导入" :visible.sync="deviceImportShow">
        <el-upload class="upload-demo" drag :headers="{ 'X-Auth-Token': token }" :action="URL"
                   :on-success="itemSuccess">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
    </el-dialog>

    <el-dialog title="计划保养项导入" :visible.sync="planMaintainShow">
        <el-upload class="upload-demo" drag :headers="{ 'X-Auth-Token': token }" :action="URL"
                   :on-success="itemSuccessPlanMaintain">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
    </el-dialog>

    <el-dialog title="点检项导入" :visible.sync="dailyCheckItemShow">
        <el-upload class="upload-demo" drag :headers="{ 'X-Auth-Token': token }" :action="URL"
                   :on-success="itemSuccessDailyCheckItem">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
    </el-dialog>

    <el-dialog :title="opcTitle" width="600px" :visible.sync="opcShow" style="text-align: left">
        <el-form :model="DeviceOpcConfig" :rules="DeviceOpcConfigRules" ref="DeviceOpcConfigRules"
                 label-width="130px" class="demo-roleForm">
            <el-form-item label="地址" prop="opcTcp">
                <el-input v-model.trim="DeviceOpcConfig.opcTcp" placeholder="请输入地址"></el-input>
            </el-form-item>
            <el-form-item v-for="config in DeviceOpcConfig.valVOAdmins" :label="config.opcValType + '采集地址'">
                <el-input v-model.trim="config.opcValAddr" placeholder="请输入采集地址"></el-input>
            </el-form-item>
            <el-form-item label="是否启用">
                <el-switch v-model="DeviceOpcConfig.isActive" active-text="是" inactive-text="否"></el-switch>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="opcShow = false">取 消</el-button>
    <el-button type="primary" @click="saveDeviceOpcConfig('DeviceOpcConfigRules')">确定</el-button>
</span>
    </el-dialog>
</div>
</template>

<script>
import { deleteDevice, deviceTemplate, getAlldevice, planMaintainImport } from '../../../libs/api'
import moment from 'moment'
import jQuery from 'jquery'

export default {
    name: 'deviceList',
    data() {
        return {
            searchParams: {
                param: {},
                pageSize: 10,
                page: 1,
                pageCount: 0
            },
            tableData: [],
            factoryTree: [],
            fcIdSelected: '',
            sectionSelected: '',
            shopSelected: '',
            lineSelected: '',
            userInfo: {},
            role: {},
            ischeck: true,
            scopeSelected: '',
            devCode: '',
            devName: '',
			devStatus: '',
            access: [],
            scopeDisabled: true,
            isclear: false,
            token: '',
            URL: '',
            deviceImportShow: false,
            planMaintainShow: false,
            dailyCheckItemShow: false,
            opcShow: false,
            opcAdd: false,
            opcTitle: '',
            DeviceOpcConfig: {
                devCode: '',
                opcTcp: '',
                fcCode: '',
                isActive: '',
                valVOAdmins: [
                    {
                        opcValAddr: '',
                        opcValType: 'STATUS'
                    },
                    {
                        opcValAddr: '',
                        opcValType: 'OK'
                    },
                    {
                        opcValAddr: '',
                        opcValType: 'NG'
                    }
                ]
            },
            DeviceOpcConfigRules: {
                opcTcp: [
                    {
                        required: true,
                        message: '请输入地址',
                        trigger: 'blur'
                    }
                ],
                opcValAddr: [
                    {
                        required: true,
                        message: '请输入采集地址',
                        trigger: 'blur'
                    }
                ]
            },
            equiStateArray: {},
            devRunStatus: '',
            isSkip: false,
            assetsNo: '',
			
			
        }
    },
    computed: {
        factoryList: function() {
            var arr = []
            var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                if (this.ischeck) {
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        for (let j = 0; j < userInfo.roles.length; j++) {
                            if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                arr.push({
                                    label: this.factoryTree[i].deptName,
                                    id: this.factoryTree[i].deptID,
                                    value: JSON.stringify(this.factoryTree[i]),
                                    deptLevel: this.factoryTree[i].deptLevel,
                                    parent: 0
                                })
                            }
                        }
                    }
                } else {
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        arr.push({
                            label: this.factoryTree[i].deptName,
                            id: this.factoryTree[i].deptID,
                            value: JSON.stringify(this.factoryTree[i]),
                            deptLevel: this.factoryTree[i].deptLevel,
                            parent: 0
                        })
                    }
                }
            }
            return arr
        },
        shopList: function() {
            var arr = []
            if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                var factory = JSON.parse(this.fcIdSelected)
                var shops = factory.child
                for (var i = 0; i < shops.length; i++) {
                    if (shops[i].hasOwnProperty('deptCode')) {
                        arr.push({
                            label: shops[i].deptName,
                            id: shops[i].deptID,
                            value: JSON.stringify(shops[i]),
                            deptLevel: shops[i].deptLevel,
                            parent: 0
                        })
                    }
                }
            }
            return arr
        },
        sectionList: function() {
            var arr = []
            if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                var shop = JSON.parse(this.shopSelected)
                var vsms = shop.child
                for (var i = 0; i < vsms.length; i++) {
                    if (vsms[i].hasOwnProperty('deptCode')) {
                        arr.push({
                            label: vsms[i].deptName,
                            id: vsms[i].deptID,
                            value: JSON.stringify(vsms[i]),
                            deptLevel: vsms[i].deptLevel,
                            parent: 0
                        })
                    }
                }
            }
            return arr
        },
        lineList: function() {
            var arr = []
            if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                var vsm = JSON.parse(this.sectionSelected)
                var lines = vsm.child
                for (var i = 0; i < lines.length; i++) {
                    if (lines[i].hasOwnProperty('deptCode')) {
                        arr.push({
                            label: lines[i].deptName,
                            id: lines[i].deptID,
                            value: JSON.stringify(lines[i]),
                            deptLevel: lines[i].deptLevel,
                            parent: 0
                        })
                    }
                }
            }
            return arr
        }
    },
    mounted() {
        this.init()
    },
    activated() {
        this.init()
    },
    methods: {
        dateFormat: function(row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format('YYYY-MM-DD')
        },
        init() {
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            this.token = sessionStorage.getItem('authToken')
            // this.userInfo = sessionStorage.getItem("userInfo")
            this.userInfo = this.$store.state.userInfo
            var role = this.userInfo.roles
            for (var i = 0; i < role.length; i++) {
                //所有工厂数据
                if (role[i].factoryId == 0) {
                    this.ischeck = false
                    this.role = role[i]
                    this.scopeDisabled = false
                    this.isclear = true
                    break
                } else {
                    if (this.userInfo.factoryId == role[i].factoryId) {
                        this.role = role[i]
                    }
                }
            }
            this.getData()
        },
        paginationChange(val) {
            this.searchParams.pageSize = val
            this.searchTable()
        },
        paginationCurrentChange(val) {
            this.searchParams.page = val
            this.searchTable()
        },
        fcChange: function() {
            this.shopSelected = ''
            this.sectionSelected = ''
            this.lineSelected = ''
            // this.getData();
            this.searchTable()
        },
        shopChange: function() {
            this.sectionSelected = ''
            this.lineSelected = ''
            // this.getData();
            this.searchTable()
        },
        sectionChange: function() {
            this.lineSelected = ''
            // this.getData();
            this.searchTable()
        },
        lineChange: function() {
            // this.getData();
            this.searchTable()
        },
        addDevice() {
            this.$router.push({ path: '/addDevice' })
        },
        getDeviceOpcConfigList(row) {
            let options = {
                method: 'get',
                url: this.$api.getDeviceOpcConfigList,
                params: {
                    devCode: row.devCode
                }
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    if (response.data != undefined && response.data != '') {
                        this.DeviceOpcConfig = JSON.parse(JSON.stringify(response.data))
                        this.opcShow = true
                        this.opcAdd = false
                        this.opcTitle = '编辑'
                    } else {
                        this.opcShow = true
                        this.opcAdd = true
                        this.opcTitle = '新增'
                        this.DeviceOpcConfig.devCode = row.devCode
                        this.DeviceOpcConfig.fcCode = row.fcCode
                        this.DeviceOpcConfig.opcTcp = ''
                        for (let i = 0; i < this.DeviceOpcConfig.valVOAdmins.length; i++) {
                            this.DeviceOpcConfig.valVOAdmins[i].opcValAddr = ''
                        }
                    }
                }
            })
        },
        saveDeviceOpcConfig(DeviceOpcConfigRules) {
            this.$refs[DeviceOpcConfigRules].validate((valid) => {
                if (valid) {
                    for (let i = 0; i < this.DeviceOpcConfig.valVOAdmins.length; i++) {
                        if (this.DeviceOpcConfig.valVOAdmins[i].opcValAddr == undefined || this.DeviceOpcConfig.valVOAdmins[i].opcValAddr == '') {
                            this.$message.error('请输入' + this.DeviceOpcConfig.valVOAdmins[i].opcValType + '采集地址！')
                            return
                        }
                    }
                    let options = {
                        method: 'POST',
                        url: this.$api.saveDeviceOpcConfig,
                        data: this.DeviceOpcConfig
                    }
                    this.$http.request(options).then(response => {
                        if (response.status == 100) {
                            this.$message.success(this.opcAdd ? '新增成功！' : '编辑成功！')
                            this.opcShow = false
                            this.searchTable()
                        } else {
                            this.$message.error(response.message)
                        }
                    })
                } else {
                    return false
                }
            })
        },
        deviceEditor(row) {
            this.$router.push({
                name: 'editDevice',
                params: {
                    device: row
                }
            })
        },
        deleteDevice(row) {
            this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$http
                        .request({
                            method: 'POST',
                            params: {
                                devId: row.devId,
                                devCode: row.devCode
                            },
                            url: this.$api.deleteDevice
                        })
                        .then(response => {
                            this.searchTable()
                            // this.$message.success(response.message);
                        })
                        .catch(err => {
                            this.searchTable()
                            // this.$message.error(err);
                        })
                })
                .catch(() => {
                    this.searchTable()
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        async exportDevice() {
            var self = this
            let queryParams = {}
            if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
            }
            if (self.shopSelected != undefined && self.shopSelected != '') {
                queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
            }
            if (self.sectionSelected != undefined && self.sectionSelected != '') {
                queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
            }
            if (self.lineSelected != undefined && self.lineSelected != '') {
                queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
            }
            if (self.devCode != undefined && self.devCode != '') {
                queryParams['devCode'] = self.devCode
            }
            if (self.devName != undefined && self.devName != '') {
                queryParams['devName'] = self.devName
            }
            if (self.devRunStatus != undefined && self.devRunStatus != '') {
                queryParams['devRunStatus'] = self.devRunStatus
            }
            if (self.assetsNo != undefined && self.assetsNo != '') {
                queryParams['assetsNo'] = self.assetsNo
            }
			if (self.devStatus != undefined && self.devStatus != '') {
			    queryParams['devStatus'] = self.devStatus
			}
            let options = {
                url: this.$api.exportDevice,
                method: 'POST',
                params: queryParams,
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                }
            }
            let result = await this.$http.request(options)
            var elink = document.createElement('a')
            elink.download = '设备信息'  //设置名称
            elink.style.display = 'none'
            var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)  //追加节点
            elink.click()
            document.body.removeChild(elink)  //删除节点
        },
        deviceTemplate() {
            if (this.fcIdSelected == undefined || this.fcIdSelected == '') {
                this.$message.error('请选择工厂！')
                return
            }
            var inputs = ''
            inputs += '<input type="hidden" name="token" value="' + this.token + '" />'
            if (this.fcIdSelected != '' && this.fcIdSelected != undefined) {
                inputs += '<input type="hidden" name="fcCode" value="' + JSON.parse(this.fcIdSelected).deptCode + '" />'
            }
            var url = this.$api.deviceTemplate

            jQuery('<form action="' + url + '" method=POST>' + inputs + '</form>')
                .appendTo('body').submit().remove()
        },
        deviceImport() {
            if (this.fcIdSelected == undefined || this.fcIdSelected == '') {
                this.$message.error('请选择工厂！')
                return
            }
            if (this.fcIdSelected != '' && this.fcIdSelected != undefined) {
                this.deviceImportShow = true
                this.URL = this.$api.deviceImport + '?fcCode=' + JSON.parse(this.fcIdSelected).deptCode
            }
        },
        itemSuccess(resp) {
            if (resp.status == 101) {
                alert(resp.message)
            } else if (resp.status == 100) {
                this.$message.success('导入成功')
                this.deviceImportShow = false
                this.searchTable()
            }
        },
        planMaintainTemplate() {
            var url = this.$api.planMaintainTemplate
            jQuery('<form action="' + url + '" method=POST> </form>')
                .appendTo('body').submit().remove()
        },
        planMaintainImport() {
            this.planMaintainShow = true
            this.URL = this.$api.planMaintainImport
        },
        itemSuccessPlanMaintain(resp) {
            if (resp.status == 101) {
                alert(resp.message)
            } else if (resp.status == 100) {
                this.$message.success('导入成功')
                this.planMaintainShow = false
            }
        },
        dailyCheckItemTemplate() {
            var url = this.$api.dailyCheckItemTemplate
            jQuery('<form action="' + url + '" method=POST> </form>')
                .appendTo('body').submit().remove()
        },
        dailyCheckItemImport() {
            this.dailyCheckItemShow = true
            this.URL = this.$api.dailyCheckItemImport
        },
        itemSuccessDailyCheckItem(resp) {
            if (resp.status == 101) {
                alert(resp.message)
            } else if (resp.status == 100) {
                this.$message.success('导入成功')
                this.dailyCheckItemShow = false
            }
        },
        getFacility() {
            this.$router.push({
                name: 'facilitySpectaculars',
                params: {
                    full: 'true'
                }
            })
        },
        searchTable() {
            let queryParams = {
                pageSize: this.searchParams.pageSize,
                pageNum: this.searchParams.page
            }
            var self = this
            if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
            }
            if (self.shopSelected != undefined && self.shopSelected != '') {
                queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
            }
            if (self.sectionSelected != undefined && self.sectionSelected != '') {
                queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
            }
            if (self.lineSelected != undefined && self.lineSelected != '') {
                queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
            }
            if (self.devCode != undefined && self.devCode != '') {
                queryParams['devCode'] = self.devCode
            }
            if (self.devName != undefined && self.devName != '') {
                queryParams['devName'] = self.devName
            }
            if (self.devRunStatus != undefined && self.devRunStatus != '') {
                queryParams['devRunStatus'] = self.devRunStatus
            }
            if (self.assetsNo != undefined && self.assetsNo != '') {
                queryParams['assetsNo'] = self.assetsNo
            }
			if (self.devStatus != undefined && self.devStatus != '') {
			    queryParams['devStatus'] = self.devStatus
			}
            let options = {
                method: 'GET',
                params: queryParams,
                url: this.$api.getAlldevice
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.tableData = response.data.data.list
                    this.searchParams.pageCount = response.data.total
                }
            })
        },
        getData() {
            var self = this
            let options = {
                method: 'GET',
                url: this.$api.departTree
            }
            this.$http.request(options).then(response => {
                this.factoryTree = response.data
                for (var i = 0; i < self.factoryTree.length; i++) {
                    if (self.factoryTree[i].deptID == self.role.factoryId) {
                        self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                    }
                    //新工厂看板
                    if (self.$route.params.equiState != undefined && self.$route.params.equiState != '') {
                        self.isSkip = true
                        self.equiStateArray = self.$route.params.equiState
                        let fcCodeList = []
                        if (self.equiStateArray.hasOwnProperty('fcCode')) {
                            fcCodeList = self.equiStateArray.fcCode.split(',')
                        }
                        if (fcCodeList.length > 1) {
                            self.equiStateArray.fcCode = fcCodeList[0]
                        }
                        self.devRunStatus = self.equiStateArray.devRunStatus
                        if (self.equiStateArray.hasOwnProperty('fcCode')) {
                            if (self.factoryTree[i].deptCode == self.equiStateArray.fcCode) {
                                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                                if (self.equiStateArray.hasOwnProperty('shopCode')) {
                                    var shops = JSON.parse(self.fcIdSelected).child
                                    for (let j = 0; j < shops.length; j++) {
                                        if (shops[j].hasOwnProperty('deptCode')) {
                                            if (shops[j].deptCode == self.equiStateArray.shopCode) {
                                                self.shopSelected = JSON.stringify(shops[j])
                                                if (self.equiStateArray.hasOwnProperty('sectionCode')) {
                                                    var sections = JSON.parse(self.shopSelected).child
                                                    for (let k = 0; k < sections.length; k++) {
                                                        if (sections[k].hasOwnProperty('deptCode')) {
                                                            if (sections[k].deptCode == self.equiStateArray.sectionCode) {
                                                                self.sectionSelected = JSON.stringify(sections[k])
                                                                if (self.equiStateArray.hasOwnProperty('lineCode')) {
                                                                    var lines = JSON.parse(self.sectionSelected).child
                                                                    for (let l = 0; l < lines.length; l++) {
                                                                        if (lines[l].hasOwnProperty('deptCode')) {
                                                                            if (lines[l].deptCode == self.equiStateArray.lineCode) {
                                                                                self.lineSelected = JSON.stringify(lines[l])
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        self.isSkip = false
                    }
                }
                this.searchTable()
            })
        }
    }
}
</script>

<style scoped>
</style>
